<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/">boodmo</a></li>
        <li class="breadcrumb-item" *ngFor="let item of breadcrumbsService.getItems"><a [routerLink]="item.route">{{item.title}}</a></li>
        <li class="breadcrumb-item active" aria-current="page" *ngIf="breadcrumbsService.currentName">{{ breadcrumbsService.currentName }}</li>
    </ol>
</nav>
